import Plugin from 'src/plugin-system/plugin.class';
//import Flickity from 'flickity';
import Swiper from 'swiper';

export default class ThermoOelPeopleGridSliderPlugin extends Plugin {

    init() {
        this._resizeBackgroundElement();
        this._registerGallery();
        this._registerEvents(); 
        this._registerControlEvents(); 
        this._registerMobileGallery();
        this._resizeGallery();
    }

    _registerEvents() {
        $( window ).on('resize', () => {
            this._resizeBackgroundElement();    
            this._resizeGallery();
        });

        $('.thermo-oel-people-grid-slider-widget__gallery-item').on('click', function (e) {
            e.preventDefault();

            var current = $(this).find('img').data('related-image-id');

            $('.thermo-oel-people-grid-slider-widget__gallery-item').removeClass('is--active');
            $(this).addClass('is--active');

            $('.thermo-oel-people-grid-slider-widget__main-image').removeClass('is--active');
            $('.thermo-oel-people-grid-slider-widget__main-image:nth-child(' + current + ')').addClass('is--active');

            $('.thermo-oel-people-grid-slider-widget__content').removeClass('is--active');
            $('.thermo-oel-people-grid-slider-widget__content:nth-child(' + current + ')').addClass('is--active');

        });
    }

    _registerControlEvents() {
        $('.thermo-oel-people-grid-slider-widget__prev').on('click', (e) => {
            e.preventDefault();

            if (this.page === 1) {
                this.page = 1;
            } else {
                this.page--;
                this._showImages();
            }

            if (this.page === 1) {
                $('.thermo-oel-people-grid-slider-widget__prev').removeClass('is--active');
            }

            if (this.page >= 1) {
                $('.thermo-oel-people-grid-slider-widget__next').addClass('is--active');
            }

            this._registerEvents(); 

        });

        $('.thermo-oel-people-grid-slider-widget__next').on('click', (e) => {
            e.preventDefault();

            if (this.page < this.pages) {
                this.page++;
                this._showImages();
            }

            if (this.page !== 1) {
                $('.thermo-oel-people-grid-slider-widget__prev').addClass('is--active');
            }

            if (this.page == this.pages) {
                $('.thermo-oel-people-grid-slider-widget__next').removeClass('is--active');
            }

            this._registerEvents(); 
        });
    }

    _resizeBackgroundElement() {
        var containerWidth = $('.container').width();
        var windowWidth = $(window).width();
        var elementWidth = $(this.el).find('.thermo-oel-people-grid-slider-widget__main-image-container').outerWidth();

        var leftGap = (windowWidth - containerWidth) / 2;
        var leftGap = leftGap + elementWidth;

        $(this.el).find('.thermo-oel-people-grid-slider-widget__main-image-background').width(leftGap + 'px');
    }

    _resizeGallery() {
        this.gallery.css('min-height', (this.gallery.children().first().children().first().height() * 2) + 40 + 'px');
    }

    _registerMobileGallery() {
        window.swiper = new Swiper(".thermo-oel-people-grid-slider-widget__mobile-images", {
            slidesPerView: 4,
            grid: {
              rows: 1,
            },
            spaceBetween: 10,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
        });
    }

    _registerGallery() {
        this.perPage = 4;
        this.page = 1;
        this.images = $('.thermo-oel-people-grid-slider-widget__images img');
        this.pages = Math.ceil(this.images.length / this.perPage);
        this.gallery = $('.thermo-oel-people-grid-slider-widget__gallery');
        this.initial = true;

        this._showImages();
    }

    _showImages() {

        this.gallery.empty();

        var offset = (this.page - 1) * this.perPage;

        for (var i = offset, ii = 0; i < offset + this.perPage; i++, ii++) {
            if (this.images[i]) {

                var item = document.createElement('div');
                var imageWrapper = document.createElement('div');
                var image = document.createElement('img');

                item.classList.add('thermo-oel-people-grid-slider-widget__gallery-item');
                imageWrapper.classList.add('thermo-oel-people-grid-slider-widget__gallery-image-wrapper');
                image.classList.add('thermo-oel-people-grid-slider-widget__gallery-image');

                if (this.initial) {
                    item.classList.add('is--active');
                }

                this.initial = false;

                // item.setAttribute('data-sal', 'slide-up');
                // item.setAttribute('data-sal-delay', ii*200);
                // item.setAttribute('data-sal-duration', 1000);

                image.setAttribute('src', this.images[i].src);
                image.setAttribute('alt', this.images[i].title);
                image.setAttribute('data-related-image-id', $(this.images[i]).data('related-image-id'));

                imageWrapper.appendChild(image);
                item.appendChild(imageWrapper);

                this.gallery.append(item);

                window.scrollAnimations.update();

            }
        }
    }

}